var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('v-col',{attrs:{"cols":"10"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('PartnerValasztasa'))+" ")]),_c('v-card-text',[_c('partnerSearch',{on:{"value":_vm.partnerSelected}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }